import React, { useState } from 'react'
import { useMutation } from 'react-apollo-hooks'
import { SettingBox } from '../../application'
import getText from '../strings'
import styled from 'react-emotion'
import { Message } from '../../styles'
import * as Mutations from '../mutations'

const Flex = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  margin-bottom: 10px;
  label {
    display: inline-block;
    margin: 5px 0;
    width: 25%;
  } 
  @media (max-width: 992px) {
    label {
      width: 50%;
    }
  }
`

const Label = styled('label')`
  display: ${props => props.editMode ? 'unset' : (props.checked ? 'inline-block' : 'none')} !important;
  input {
    display: ${props => props.editMode ? 'inline-block' : 'none'} !important;
  }
`

export default ({ airports, onSave }) => {
  const initialAirports = airports || []
  const [editMode, setEditMode] = useState(false)
  const [data, setData] = useState(initialAirports)
  const [error, setError] = useState(false)

  const saveAirports = useMutation(Mutations.saveAirports, {
    update: (proxy, mutationResult) => {
      if (mutationResult.data.saveAirports) {
        onSave()
        setEditMode(false)
      }
      else {
        setData(initialAirports)
        setError(true)
      }
    }
  })

  const handleToggleEditMode = () => {
    if (editMode) {
      setError(false)
      setData(initialAirports)
    }
    setEditMode(!editMode)
  }

  const handleAirportChange = (checked, id) => {
    setData(data.map(p => ({
      ...p,
      selected: p.id === id ? checked : p.selected
    })))
  }

  const handleSubmit = () => {
    setError(false)
    saveAirports({
      variables: {
        airportIds: data.filter(p => p.selected).map(p => p.id)
      }
    })
  }

  return (
    <SettingBox {...{ editMode, header: getText('airports', 'departureAirports') }}>
      <p>{getText('airports', 'departureAirportsInformation')}</p>
      <Flex>
        {data.map(airport => (
          <Label key={airport.id} checked={airport.selected} editMode={editMode}>
            <input id={airport.id} type="checkbox" checked={airport.selected} onChange={(e) => handleAirportChange(e.target.checked, airport.id)} />
            {airport.name}
          </Label>
        ))}
      </Flex>
      {editMode && error &&
        <Message error={true}>{getText('errors', 'general')}</Message>
      }
      <SettingBox.Footer>
        <SettingBox.Edit>
          <button
            className="btn btn-function"
            onClick={handleSubmit}>
            {getText('editProfile', 'form', 'saveChanges')}
          </button>
        </SettingBox.Edit>
        <button
          onClick={handleToggleEditMode}
          className="btn ghost-blue"
          type="button">
          {editMode ? getText('buttons', 'cancel') : getText('airports', 'editAirports')}
        </button>
      </SettingBox.Footer>
    </SettingBox>
  )
}